(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  /* Recently viewed: remember product handles visited in this browser (newest first). */
  (() => {
    const KEY = 'Diecela:recently-viewed';
    const read = () => {
      try {
        const list = JSON.parse(localStorage.getItem(KEY));
        return Array.isArray(list) ? list : [];
      } catch (e) {
        return [];
      }
    };
    const current = document.querySelector('.template-product product-info[data-handle]')?.dataset.handle;
    if (current) {
      try {
        localStorage.setItem(KEY, JSON.stringify([current, ...read().filter((h) => h !== current)].slice(0, 12)));
      } catch (e) {}
    }

    if (customElements.get('recently-viewed')) return;
    const cache = new Map();
    const load = (handle) => {
      if (!cache.has(handle)) {
        const root = (window.Diecela?.routes?.root_url || '/').replace(/\/$/, '');
        cache.set(
          handle,
          fetch(`${root}/products/${encodeURIComponent(handle)}?section_id=recent-product-card`)
            .then((res) => (res.ok ? res.text() : ''))
            .then((html) => new DOMParser().parseFromString(html, 'text/html').querySelector('.upsell-card'))
            .catch(() => null)
        );
      }
      return cache.get(handle);
    };

    customElements.define(
      'recently-viewed',
      class extends HTMLElement {
        async connectedCallback() {
          const exclude = new Set((this.dataset.exclude || '').split(',').filter(Boolean));
          const handles = read()
            .filter((h) => !exclude.has(h))
            .slice(0, Number(this.dataset.limit) || 6);
          if (!handles.length) return;
          const cards = (await Promise.all(handles.map(load))).filter(Boolean);
          const shell = this.querySelector('template[data-recent-shell]');
          if (!cards.length || !shell || !this.isConnected) return;
          const content = shell.content.cloneNode(true);
          content.querySelector('[data-track]').append(...cards.map((card) => card.cloneNode(true)));
          this.replaceChildren(content);
        }
      }
    );
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('newsletter-popup')) {
    customElements.define(
      'newsletter-popup',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          if (!this.dialog) return;
          this.key = `newsletter-popup:${this.dataset.sectionId}`;

          // In the editor the merchant is looking at this section on purpose, so it
          // opens when they select it and never on a timer — a popup that reappears
          // every few seconds makes the section impossible to style.
          if (this.hasAttribute('data-design-mode')) {
            document.addEventListener('shopify:section:select', (e) => {
              if (e.detail?.sectionId === this.dataset.sectionId) this.show();
            });
            document.addEventListener('shopify:section:deselect', () => this.dialog.close());
            return;
          }

          // A submitted form reloads the page with the result on it, so the popup has
          // to come back to show whether it worked.
          if (this.querySelector('.form-message')) {
            this.show();
            return;
          }

          if (!this.due()) return;
          this.timer = setTimeout(() => this.show(), Number(this.dataset.delay || 0) * 1000);
          this.dialog.addEventListener('close', () => this.remember(), { once: true });
        }

        disconnectedCallback() {
          clearTimeout(this.timer);
        }

        /** Shown recently enough that asking again would just be nagging? */
        due() {
          try {
            const seen = Number(localStorage.getItem(this.key));
            if (!seen) return true;
            const days = Number(this.dataset.frequency || 0);
            // 0 days means "once, ever".
            if (!days) return false;
            return Date.now() - seen > days * 86400000;
          } catch {
            // Private mode: show it this once rather than never.
            return true;
          }
        }

        remember() {
          try {
            localStorage.setItem(this.key, String(Date.now()));
          } catch {
            /* Nothing to do: it will ask again next visit, which is the safe way to fail. */
          }
        }

        show() {
          if (this.dialog.open) return;
          this.dialog.showModal();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
